<template>
  <div v-if="body_show" class="base-class-main">
    <div class="bg"></div>
    <!-- 主题内容 -->
    <div class="base-class-box">
        <img class="logo" src="@a/other/base_class/base_class_logo.png" />
        <div class="userinfo">
          <h3>{{item.name}}</h3>
          <h4>所在班级：{{item.class_name}}</h4>
          <h4 class="on">所在小组：{{item.group_no}}组</h4>
          <div class="hr"></div>
          <div class="t-qrcode">
            <div class="left">
              <h5 class="on">小组促动师：{{item.lf}}</h5>
              <h5>长按识别二维码添加老师</h5>
            </div>
            <img :src="item.lf_qrcode" alt="" />
          </div>
        </div>
        <!-- group -->
        <div class="g-box">
          <h3>我所在小组的其他同学</h3>
          <div v-for="(child,index) in list" :key="index" class="g-box-child">
            <div class="left"><span>{{index+1}}</span></div>
            {{child}}
          </div>
        </div>
        <!-- img -->
        <div class="g-box">
          <h3>本期课程的课表信息<span>（课程表可长按保存）</span></h3>
          <img v-if="item.curriculum" :src="item.curriculum" width="100%" alt="">
          <img v-else src="@a/other/base_class/curriculum.png" width="100%" alt="">
          
        </div>
    </div>
  </div>
</template>

<script>
import { search } from "@/api/other";
export default {
  data() {
    return {
      body_show: false,
      list: [],
      item:{}
    }
  },
  methods: {
    // 初始化方法
    pullData() {
      //调用加载中
      this.$emit("loadingHandle", true, "拼命加载中...");
      search({
        class_name:this.$route.query.name,
        phone:this.$route.query.phone
      }).then(data => {
        if(data.code==10002){
          this.$router.push('/online_base_class');
          
        }else{
          this.list = data.group;
          this.item = data.item;
          document.title = "查询个人信息";
          this.body_show = true;
        }
        
        //关闭加载中
        this.$emit("loadingHandle", false);
      });
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
.base-class-main{
    position: relative;
    .bg{
        height:305px;
        background-color:#1C95D4;
    }
    .base-class-box{
      margin-top: -305px;
      padding: 30px 40px 80px;
      background: transparent;
      .logo{
        width: 137px;
        height: 56px;
        margin-bottom: 44px;
      }
      .g-box{
        padding: 50px 40px;
        border-radius:12px;
        background-color: #fff;
        margin-bottom: 30px;
        h3{
          font-size: 36px;
          color: #1C95D4;
          line-height: 1;
          margin-bottom: 50px;
          font-weight: bold;
          span{
            font-size: 26px;
            color: #999999;
          }
        }
        .g-box-child{
          display: flex;
          align-items: center;
          line-height: 74px;
          border-radius:12px;
          overflow: hidden;
          background:rgba(28,149,212,.1);
          margin-bottom: 2px;
          font-size: 28px;
          color: #333333;
          font-weight:500;
          .left{
            width: 150px;
            border-radius:12px;
            background-color: #1C95D4;
            display: flex;
            height: 74px;
            align-items: center;
            justify-content: center;
            margin-right: 50px;
            span{
              display: block;
              border-radius: 50%;
              width: 34px;
              height: 34px;
              text-align: center;
              line-height: 34px;
              background-color: #fff;
              color: #1C95D4;
              font-weight: bold;
              border: 2px solid #fff;
            }
          }
        }
      }
      .userinfo{
        padding: 50px 40px;
        border-radius:12px;
        background-color: #fff;
        margin-bottom: 30px;
        h3{
          font-size: 36px;
          color: #1C95D4;
          line-height: 1;
          margin-bottom: 38px;
          font-weight: bold;
        }
        h4{
          font-size: 28px;
          color: #1C95D4;
          margin-bottom: 20px;
          line-height: 1;
        }
        h4.on{
          margin-bottom: 30px;
        }
        div.hr{
          height: 2px;
          background-color: #F2F2F2;
          margin-bottom: 30px;
        }
        .t-qrcode{
          display: flex;
          align-items: center;
          h5.on{
            font-size: 28px;
            color: #333333;
            line-height: 1;
            margin-bottom: 20px;
          }
          img{
            width: 100px;
            height: 100px;
            margin-left: auto;
          }
        }
        
      }
    }
}
</style>